export class DrawingEuroGroupRequestdto {
    matchDays: number[];
    championsLeagueBaskets: number[][];
    euroLeagueBaskets: number[][];
    conferenceLeagueBaskets: number[][];
}